import { render, staticRenderFns } from "./SidebarPOL.vue?vue&type=template&id=98a547b6&"
import script from "./SidebarPOL.vue?vue&type=script&lang=js&"
export * from "./SidebarPOL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports